import React, { PureComponent } from 'react';
import spokePropTypes from '../utils/spoke-prop-types';
import { bannerAdTypes } from '../utils/spoke-value-lists';

// Listing Ads
import {
  Portrait,
  Skyscraper,
  WideSkyscraper,
  VerticalRectangle,
  TripleWidescreen,
  HalfPage,
  InlineRectangle,
  LargeRectangle,
  Square,
  SmallSquare,
  Leaderboard,
  LargeLeaderboard,
  MobileBanner,
  LargeMobileBanner,
  Banner,
  Panorama,
  TopBanner,
  Billboard,
  Netboard
} from './banner-ads/agent';

export default class AgentBannerAd extends PureComponent {
  static propTypes = {
    ...spokePropTypes
  };

  render() {
    const { adContentSet, adType } = this.props;
    switch (adType) {
      case bannerAdTypes.LEADERBOARD:
        return <Leaderboard {...adContentSet} />;
      case bannerAdTypes.PROTRAIT:
        return <Portrait {...adContentSet} />;
      case bannerAdTypes.HALF_PAGE:
        return <HalfPage {...adContentSet} />;
      case bannerAdTypes.INLINE_RECTANGLE:
        return <InlineRectangle {...adContentSet} />;
      case bannerAdTypes.LARGE_RECTANGLE:
        return <LargeRectangle {...adContentSet} />;
      case bannerAdTypes.SQUARE:
        return <Square {...adContentSet} />;
      case bannerAdTypes.SMALL_SQUARE:
        return <SmallSquare {...adContentSet} />;
      case bannerAdTypes.TRIPLE_WIDESCREEN:
        return <TripleWidescreen {...adContentSet} />;
      case bannerAdTypes.VERTICAL_RECTANGLE:
        return <VerticalRectangle {...adContentSet} />;
      case bannerAdTypes.NETBAORD:
        return <Netboard {...adContentSet} />;
      case bannerAdTypes.SKYSCRAPER:
        return <Skyscraper {...adContentSet} />;
      case bannerAdTypes.WIDE_SKYSCRAPER:
        return <WideSkyscraper {...adContentSet} />;
      case bannerAdTypes.BANNER:
        return <Banner {...adContentSet} />;
      case bannerAdTypes.TOP_BANNER:
        return <TopBanner {...adContentSet} />;
      case bannerAdTypes.LARGE_LEADERBOARD:
        return <LargeLeaderboard {...adContentSet} />;
      case bannerAdTypes.BILLBOARD:
        return <Billboard {...adContentSet} />;
      case bannerAdTypes.PANORAMA:
        return <Panorama {...adContentSet} />;
      case bannerAdTypes.MOBILE_BANNER_LONG:
        return <LargeMobileBanner {...adContentSet} />;
      case bannerAdTypes.MOBILE_BANNER_SHORT:
        return <MobileBanner {...adContentSet} />;
      default:
        return <span>Type {adType} not found</span>;
    }
  }
}
